import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { apiConversation } from 'api'
import { getStaticImage } from 'utils/statics'
import { InputControls } from 'components/common'

const AutomatizationPlugin = ({ user, setting }) => {
  const [isChecked, setIsChecked] = useState(user.isAutomationEnabled || false)
  const modules = useSelector(state => state.modules)

  useEffect(() => {
    setIsChecked(user.isAutomationEnabled || false)
  }, [user.isAutomationEnabled])

  const activateAutomatization = async (value) => {
    const prevValue = value
    const data = {
      ...user,
      isAutomationEnabled: value
    }

    setIsChecked(value)
    apiConversation.users.updateUser(data)
      .then(result => {
        if (result.status !== 200) setIsChecked(prevValue)
      })
      .catch(() => setIsChecked(prevValue))
  }

  const automatizationDisable = () => {
    if (user.isRemoveByUser) return true
    if (!modules.faqConsole.isActive && !modules.faqConsoleAssistant.isActive) return true
    if (!setting.isChannelAutomationEnabled) return true
    if (!setting.isSmartChatActive && !setting.isFaqConsoleActive && !setting.isVirtualAssistantActive) return true

    return false
  }

  return (
    <div className={`automatization-plugin ${user.isRemoveByUser ? 'disabled' : ''}`}>
      <div className='automatization-plugin__switch'>
        <div className='automatization-plugin__title'>
          <figure className='automatization-plugin__icon'>
            <img src={getStaticImage('/icons/orange-brand/icon-automation-dark.svg')} alt='Automation' />
          </figure>
          <span>{I18n.t('dashboard_automation')}</span>
        </div>
        <InputControls
          injectType='external'
          value={automatizationDisable() ? false : isChecked}
          onChange={() => activateAutomatization(!isChecked)}
          disabled={automatizationDisable()}
        />
      </div>
    </div>
  )
}

export default AutomatizationPlugin
